import Flickity from 'flickity';

const announcementBar = () => {
  const announcementWrapper = document.querySelector('.announcement');
  const announcementEls = document.querySelectorAll('.announcement__text');
  const announcementSliderEl = document.querySelector('.announcement__content-wrapper');

  const uniqueAnnouncementID =
    announcementWrapper && announcementWrapper.dataset && announcementWrapper.dataset.blocksid;

  if (announcementWrapper) {
    const dismissButton = announcementWrapper.querySelector('.btn--dismiss');
    dismissButton.addEventListener('click', () => {
      document.body.classList.remove('has-announcement');
      announcementWrapper.style.display = 'none';
      window.localStorage.setItem('announcementBar', uniqueAnnouncementID);
      const customEvent = new CustomEvent('JB-header-nav-pin-change');
      window.dispatchEvent(customEvent);
    });

    if (announcementEls.length > 1 && announcementSliderEl) {
      const autoplaySetting = JSON.parse(announcementSliderEl.dataset.autoplay);
      const autoplaySpeedSetting = Number(announcementSliderEl.dataset.autoplayspeed);

      new Flickity(announcementSliderEl, {
        groupCells: 1,
        autoPlay: autoplaySetting && autoplaySpeedSetting,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        cellAlign: 'left',
        setGallerySize: false,
      });
    }
  }
};

export default announcementBar;
